import React from "react";
import styles from "./Banner.module.scss";

export default function Banner({id}) {

    const ins = '<iframe src="https://ad.doubleclick.net/ddm/adi/'+id+';sz=300x600;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755}?" width="300" height="600" MARGINWIDTH=0 MARGINHEIGHT=0 HSPACE=0 VSPACE=0 FRAMEBORDER=0 SCROLLING=no BORDERCOLOR="#000000"><script language="JavaScript1.1" src="https://ad.doubleclick.net/ddm/adj/'+id+';abr=!ie;sz=300x600;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755}?"> </script> </iframe>';
    return (
            <div className={styles.Main} dangerouslySetInnerHTML={{__html: ins}}/>
    )
}